var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.titleLabel, iconFA: "users" } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      inputLabel: _vm.$t("businessMembers.team_name"),
                      placeholderValue: _vm.$t("businessMembers.team_name"),
                    },
                    model: {
                      value: _vm.labelTeam,
                      callback: function ($$v) {
                        _vm.labelTeam = $$v
                      },
                      expression: "labelTeam",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", [
            _c("label", { staticClass: "col-4 col-sm-2 col-form-label" }, [
              _vm._v(_vm._s(_vm.$t("common.email_notification"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-8 col-sm-10" }, [
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-control custom-radio custom-control-inline",
                  },
                  [
                    _c("input", {
                      staticClass: "custom-control-input",
                      attrs: {
                        type: "radio",
                        id: "radioemail1",
                        name: "radioEmail",
                        value: "NO",
                        title: _vm.$t("administration.no"),
                        disabled: !_vm.isEditable,
                      },
                      domProps: { checked: _vm.isEmailContact === "NO" },
                      on: {
                        change: function ($event) {
                          _vm.isEmailContact = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "radioemail1" },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.no_label")))]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-control custom-radio custom-control-inline",
                  },
                  [
                    _c("input", {
                      staticClass: "custom-control-input",
                      attrs: {
                        type: "radio",
                        id: "radioemail2",
                        name: "radioEmail",
                        value: "YES",
                        title: _vm.$t("common.yes_label"),
                        disabled: !_vm.isEditable,
                      },
                      domProps: { checked: _vm.isEmailContact === "YES" },
                      on: {
                        change: function ($event) {
                          _vm.isEmailContact = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "custom-control-label",
                        attrs: { for: "radioemail2" },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.yes_label")))]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.isEmailContact === "YES"
            ? _c("div", { staticClass: "form-group row" }, [
                _c("div", { staticClass: "col-4 col-sm-2 col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("common.eml_adrs"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-8 col-sm-10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.emailNotification,
                        expression: "emailNotification",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: _vm.emailaddressLabel,
                      disabled: !_vm.isEditable,
                    },
                    domProps: { value: _vm.emailNotification },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.emailNotification = $event.target.value
                      },
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isEmailContact === "YES"
            ? _c("div", { staticClass: "form-group row" }, [
                _c("div", { staticClass: "col-4 col-sm-2 col-form-label" }, [
                  _vm._v(_vm._s(_vm.$t("common.min_amount"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-8 col-sm-10" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.amountNotification,
                        expression: "amountNotification",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: _vm.amountLabel,
                      disabled: !_vm.isEditable,
                    },
                    domProps: { value: _vm.amountNotification },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.amountNotification = $event.target.value
                      },
                    },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.hasGroups
            ? _c(
                "div",
                { staticClass: "row headerGroupList showLargeScreenOnly" },
                [
                  _c("label", { staticClass: "col-md-1 col-form-label" }, [
                    _vm._v(_vm._s(_vm.$t("businessMembers .group_layer"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "col-md-2 col-form-label text-left" },
                    [_vm._v(_vm._s(_vm.$t("businessMembers.grp_nm")))]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "col-md-1 col-form-label" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "col-md-2 col-form-label text-left" },
                    [_vm._v(_vm._s(_vm.$t("businessMembers.mmbr")))]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "col-md-1 col-form-label" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "col-md-1 col-form-label",
                      staticStyle: { "padding-left": "22px" },
                    },
                    [_vm._v(_vm._s(_vm.$t("businessMembers.vsblty")))]
                  ),
                  _vm._v(" "),
                  _c("label", { staticClass: "col-md-2 col-form-label" }, [
                    _vm._v(_vm._s(_vm.$t("common.rm_label"))),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "col-md-2 col-form-label" }, [
                    _vm._v(_vm._s(_vm.$t("businessMembers.grp_actns"))),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortedArray, function (group, index) {
            return !_vm.isSmartphone
              ? _c(
                  "div",
                  { key: index },
                  [
                    _c(
                      "b-row",
                      { staticClass: "groupDiv showLargeScreenOnly" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "arrow-box", attrs: { cols: "1" } },
                          [
                            _c("b-row", [
                              index === 0
                                ? _c("i", {
                                    staticClass:
                                      "icon icon-arrow-disabled icon-arrow-sort icon-arrow-sort-up fa fa-caret-up",
                                  })
                                : _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.upGroupLevel(group.label)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon icon-arrow-sort icon-arrow-sort-up fa fa-caret-up",
                                        class: _vm.canEditGroupOrderStyle,
                                      }),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("label", { staticClass: "lvl-group row" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            _c("b-row", [
                              index < _vm.sortedArray.length - 1
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.lowerGroupLevel(
                                            group.label
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down",
                                        class: _vm.canEditGroupOrderStyle,
                                      }),
                                    ]
                                  )
                                : _c("i", {
                                    staticClass:
                                      "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down icon-arrow-disabled",
                                  }),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "row col-md-11 groupDivContainers" },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "leftGroupDiv",
                                attrs: { md: "2" },
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-form-label label-group longword-word",
                                  },
                                  [_c("b", [_vm._v(_vm._s(group.label))])]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "rightGroupDiv",
                                attrs: { md: "8" },
                              },
                              _vm._l(group.members, function (member, index) {
                                return _c(
                                  "b-row",
                                  { key: index },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "col-7 col-md-7 longword-word",
                                      },
                                      [_vm._v(_vm._s(member.identifier))]
                                    ),
                                    _vm._v(" "),
                                    _c("swatches", {
                                      staticClass: "col-2 col-md-2",
                                      attrs: {
                                        "trigger-style": {
                                          width: "20px",
                                          height: "20px",
                                        },
                                        colors: _vm.colors,
                                        "row-length": "5",
                                        shapes: "squares",
                                        "popover-to": "right",
                                        "swatch-size": "20",
                                        disabled: !_vm.canChangeVisibility,
                                      },
                                      on: {
                                        open: function ($event) {
                                          return _vm.setCurrentMemberModifyVisibility(
                                            group.label,
                                            index
                                          )
                                        },
                                        close: function ($event) {
                                          return _vm.setMemberVisibility($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.membersColor[member.index],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.membersColor,
                                            member.index,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "membersColor[member.index]",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "col-1 col-md-1",
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeMemberFromGroup(
                                              group.label,
                                              member.identifier
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "icon icon-delete-member fa fa-times",
                                          style:
                                            _vm.canRemoveMemberFromGroupStyle,
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "col-1 col-md-1",
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass: "actionGroupDiv",
                                attrs: { md: "2" },
                              },
                              [
                                _c("b-row", [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "button-action button-add-mbr button-delete-group",
                                      attrs: {
                                        href: "/accountMembers/addMemberGroupMembersList/",
                                        disabled: !_vm.canAddMemberToGroup,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setCurrentGroupNumber(
                                            group.label
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("f7-icon", {
                                        staticClass: "smallIcons",
                                        attrs: { f7: "add" },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "businessMembers.add_member_small"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("b-row", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "button-action button-delete-group button-add-mbr",
                                      attrs: {
                                        round: "",
                                        type: "button",
                                        disabled: !_vm.canDeleteGroup,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteGroup(group.label)
                                        },
                                      },
                                    },
                                    [
                                      _c("f7-icon", {
                                        staticClass: "smallIcons",
                                        attrs: { f7: "trash" },
                                      }),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("businessMembers.rm_group")
                                          ) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "showSmallScreenOnly" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "arrow-box", attrs: { cols: "1" } },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "row",
                                attrs: {
                                  href: "#",
                                  disabled: !_vm.canEditGroupOrder,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.upGroupLevel(group.label)
                                  },
                                },
                              },
                              [
                                index === 0
                                  ? _c("i", {
                                      staticClass:
                                        "icon icon-arrow-disabled icon-arrow-sort icon-arrow-sort-up fa fa-caret-up",
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "icon icon-arrow-sort icon-arrow-sort-up fa fa-caret-up",
                                      class: _vm.canEditGroupOrderStyle,
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c("label", { staticClass: "lvl-group row" }, [
                              _vm._v(_vm._s(index + 1)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "row",
                                attrs: {
                                  href: "#",
                                  disabled: !_vm.canEditGroupOrder,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.lowerGroupLevel(group.label)
                                  },
                                },
                              },
                              [
                                index < _vm.sortedArray.length - 1
                                  ? _c("i", {
                                      staticClass:
                                        "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down",
                                      class: _vm.canEditGroupOrderStyle,
                                    })
                                  : _c("i", {
                                      staticClass:
                                        "icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down icon-arrow-disabled",
                                    }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "card", attrs: { cols: "10" } },
                          [
                            _c("div", { staticClass: "card-header" }, [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "col-form-label label-group longword-word",
                                },
                                [_c("b", [_vm._v(_vm._s(group.label))])]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(group.members, function (member, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "row mobile-card-body",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "col-7 col-md-7 longword-word emailsize",
                                    },
                                    [_vm._v(_vm._s(member.identifier))]
                                  ),
                                  _vm._v(" "),
                                  _c("swatches", {
                                    staticClass: "col-2 col-md-2",
                                    attrs: {
                                      "trigger-style": {
                                        width: "20px",
                                        height: "20px",
                                      },
                                      colors: _vm.colors,
                                      "row-length": "5",
                                      shapes: "squares",
                                      "popover-to": "right",
                                      "swatch-size": "20",
                                    },
                                    on: {
                                      open: function ($event) {
                                        return _vm.setCurrentMemberModifyVisibility(
                                          group.label,
                                          index
                                        )
                                      },
                                      close: function ($event) {
                                        return _vm.setMemberVisibility($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.membersColor[member.index],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.membersColor,
                                          member.index,
                                          $$v
                                        )
                                      },
                                      expression: "membersColor[member.index]",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "col-1 col-md-1",
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeMemberFromGroup(
                                            group.label,
                                            member.identifier
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "icon icon-delete-member fa fa-times",
                                        style:
                                          _vm.canRemoveMemberFromGroupStyle,
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-1 col-md-1" }),
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-footer" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "button-action button-delete-group btn-mobile-footer",
                                  attrs: {
                                    href: "/accountMembers/addMemberGroupMembersList/",
                                    disabled: _vm.canAddMemberToGroup,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setCurrentGroupNumber(
                                        group.label
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("f7-icon", {
                                    staticClass: "smallIcons",
                                    attrs: { f7: "add" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          "businessMembers.add_member_small"
                                        )
                                      ) +
                                      "\n            "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "button-action button-delete-group btn-mobile-footer",
                                  attrs: {
                                    round: "",
                                    type: "button",
                                    disabled: !_vm.canDeleteGroup,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteGroup(group.label)
                                    },
                                  },
                                },
                                [
                                  _c("f7-icon", {
                                    staticClass: "smallIcons",
                                    attrs: { f7: "trash" },
                                  }),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t("businessMembers.rm_group")
                                      ) +
                                      "\n            "
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "groupDiv justify-content-end" },
            [
              _c(
                "f7-button",
                {
                  staticClass:
                    "attachmentButton buttonAccordionForm longword-word milkyBlockBlack",
                  staticStyle: { "margin-bottom": "1rem" },
                  attrs: { round: "", disabled: !_vm.canAddNewGroup },
                  on: { click: _vm.addNewGroup },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("businessMembers.add_group")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footerButtons" },
        [
          _vm.isInViewMode === true
            ? _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "10", "offset-md": "1" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "height-button",
                              attrs: { cols: "6", md: "3", "offset-md": "9" },
                            },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  on: { click: _vm.addTeam },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "save" } }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.sve"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "b-row",
                { staticClass: "justify-content-start" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "10", "offset-md": "1" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "3", "offset-md": "6" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  attrs: { disabled: !_vm.isDeletable },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteTeam()
                                    },
                                  },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "trash" } }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("businessMembers.dlt_tm"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { md: "3" } },
                            [
                              _c(
                                "f7-button",
                                {
                                  staticClass: "button-action milkyBlockBlack",
                                  attrs: { disabled: !_vm.isEditable },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editTeam()
                                    },
                                  },
                                },
                                [
                                  _c("f7-icon", { attrs: { fa: "save" } }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("common.valid_chgs"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }